export const blockIconsHouseholdBedNew = (
	<span className='material-symbols-outlined'>bed</span>
);
